const state = {
  auth_data: {},
};
export default state;
